package one.healthium.payments.di

import one.healthium.payments.BillingManager
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

internal actual fun paymentsPlatformModule() = module {
    singleOf(::BillingManager)
}